import { FC as ReactFC } from 'react';

import styles from './groupFilterTag.module.scss';
import GroupFilterTagProps from './GroupFilterTagProps';

const GroupFilterTag: ReactFC<GroupFilterTagProps> = (
  props: GroupFilterTagProps
) => {
  const { groupFilter } = props;
  const { name, value } = groupFilter;

  return (
    <div className={`truncate ${styles.groupTag}`}>
      <span>{`${name},`}</span>&nbsp;
      <span className="truncate">{`${value}`}</span>&nbsp;
    </div>
  );
};

export default GroupFilterTag;
